function t(t,e){return Reflect.getMetadata(e,t)}function e(e,n,a,c){const f=c(t(e,n)??a);Reflect.defineMetadata(n,f,e)}export{t as getReflectMetadata,e as updateReflectMetadata};
//# sourceMappingURL=index.js.map
